var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg403(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 456,
    viewBox: "0 0 535 456",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1230_44876",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 70,
    width: 501,
    height: 366
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M534.004 70H34.8696V435.092H534.004V70Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1230_44876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.481 400.99C372.348 400.99 453.305 376.741 453.305 346.828C453.305 316.915 372.348 292.666 272.481 292.666C172.615 292.666 91.6572 316.915 91.6572 346.828C91.6572 376.741 172.615 400.99 272.481 400.99Z",
    fill: "url(#paint0_linear_1230_44876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.713 291.091C137.713 291.091 137.633 290.877 137.525 291.106C136.553 293.169 127.753 315.513 127.055 332.759C127.055 332.759 125.586 342.668 137.892 342.536C148.165 342.427 147.892 333.293 147.856 330.216C147.715 317.734 137.713 291.091 137.713 291.091Z",
    fill: "url(#paint1_linear_1230_44876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.432 353.508C137.234 353.508 137.072 353.339 137.072 353.132V297.099C137.072 296.892 137.234 296.723 137.432 296.723C137.63 296.723 137.792 296.892 137.792 297.099V353.132C137.792 353.342 137.63 353.508 137.432 353.508Z",
    fill: "url(#paint2_linear_1230_44876)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.831 325.994C424.378 325.158 426.848 324.066 429.1 321.009C429.562 320.383 429.996 319.58 429.743 318.83C429.552 318.266 429.001 317.904 428.441 317.812C428.232 317.78 428.021 317.774 427.811 317.794H427.809C427.486 317.829 427.166 317.895 426.855 317.992L426.766 318.019C425.281 318.466 423.865 319.143 422.566 320.028C422.449 320.107 422.309 320.143 422.17 320.127C422.031 320.112 421.901 320.048 421.802 319.944C421.702 319.841 421.638 319.705 421.62 319.558C421.603 319.411 421.633 319.263 421.705 319.136C421.837 318.907 421.992 318.693 422.165 318.496C422.421 318.213 422.701 317.955 423.002 317.727C423.403 317.418 423.83 317.142 424.248 316.859C425.802 315.811 427.274 314.633 428.65 313.336C429.632 312.409 430.593 311.381 431.06 310.078C431.275 309.479 431.372 308.788 431.116 308.207C430.694 307.254 429.498 306.987 428.52 307.184C426.806 307.532 425.437 308.863 424.223 310.189C423.216 311.291 422.088 312.511 420.641 312.579C420.395 312.603 420.147 312.551 419.928 312.427C419.516 312.163 419.41 311.549 419.557 311.063C419.704 310.575 420.044 310.187 420.373 309.813C422.282 307.643 424.161 305.386 425.401 302.728C426.641 300.07 427.19 296.931 426.328 294.109C426.076 293.283 425.696 292.48 425.104 291.881C424.512 291.282 423.682 290.906 422.869 291.021C421.762 291.175 420.928 292.164 420.366 293.187C418.438 296.693 418.556 300.99 418.013 305.007C417.861 306.132 417.64 307.285 417.007 308.211C416.949 308.3 416.873 308.375 416.785 308.43C416.265 308.749 415.798 308.106 415.602 307.56C414.831 305.399 414.638 302.928 413.257 301.139C412.73 300.458 411.984 299.889 411.153 299.895C410.138 299.902 409.269 300.8 408.972 301.828C408.676 302.857 408.854 303.974 409.171 304.995C409.76 306.889 410.816 308.59 412.06 310.085C412.716 310.875 413.458 311.672 413.654 312.702C413.715 313.052 413.689 313.413 413.581 313.749C413.473 314.086 413.285 314.388 413.035 314.627C412.919 314.734 412.783 314.816 412.636 314.867C412.489 314.918 412.334 314.936 412.18 314.923C411.847 314.891 411.546 314.711 411.254 314.536C411.132 314.462 411.01 314.388 410.887 314.314C410.402 314.022 409.917 313.729 409.431 313.436C408.197 312.69 406.708 311.929 405.423 312.571C404.768 312.899 404.338 313.544 404.136 314.284C403.955 314.956 403.955 315.668 404.136 316.34C404.519 317.738 406.931 321.627 407.926 322.63C409.088 323.801 413.119 328.854 421.831 325.994Z",
    fill: "url(#paint3_linear_1230_44876)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.826 345.293C241.089 344.535 241.266 343.677 241.316 342.668C241.343 342.134 241.289 341.514 240.873 341.197C240.56 340.959 240.121 340.977 239.776 341.149C239.649 341.214 239.529 341.295 239.42 341.39L239.418 341.391C239.252 341.539 239.099 341.704 238.961 341.882L238.922 341.932C238.261 342.774 237.723 343.716 237.326 344.727C237.289 344.818 237.224 344.893 237.142 344.94C237.059 344.987 236.963 345.003 236.87 344.985C236.776 344.967 236.691 344.917 236.627 344.842C236.564 344.768 236.526 344.673 236.52 344.574C236.509 344.393 236.516 344.212 236.54 344.034C236.578 343.774 236.64 343.518 236.723 343.271C236.811 343.003 236.917 342.74 237.022 342.478C237.047 342.415 237.072 342.353 237.097 342.29C237.576 341.087 237.961 339.843 238.25 338.572C238.455 337.664 238.611 336.707 238.393 335.795C238.292 335.376 238.093 334.952 237.737 334.73C237.153 334.368 236.39 334.696 235.919 335.196C235.095 336.074 234.822 337.361 234.634 338.584C234.48 339.6 234.3 340.73 233.522 341.344C233.393 341.456 233.237 341.526 233.07 341.544C232.743 341.561 232.459 341.262 232.362 340.932C232.265 340.602 232.312 340.25 232.357 339.91C232.621 337.94 232.837 335.933 232.55 333.957C232.263 331.982 231.417 330.014 229.902 328.785C229.459 328.426 228.953 328.13 228.404 328.032C227.855 327.934 227.256 328.056 226.846 328.444C226.288 328.972 226.187 329.856 226.251 330.649C226.414 332.706 227.39 334.548 228.364 336.384C228.679 336.979 228.995 337.573 229.282 338.174C229.61 338.861 229.91 339.592 229.899 340.36C229.899 340.433 229.885 340.505 229.856 340.571C229.684 340.956 229.188 340.784 228.879 340.558C228.482 340.266 228.106 339.931 227.731 339.597C226.954 338.906 226.18 338.216 225.219 337.916C224.677 337.747 224.053 337.727 223.594 338.062C223.032 338.471 222.879 339.318 223.092 340.009C223.305 340.7 223.813 341.252 224.364 341.694C225.387 342.514 226.598 343.041 227.838 343.378C227.902 343.395 227.966 343.412 228.03 343.429C228.627 343.588 229.244 343.753 229.685 344.2C229.846 344.371 229.965 344.582 230.028 344.813C230.092 345.043 230.098 345.287 230.047 345.519C230.022 345.625 229.976 345.725 229.913 345.812C229.85 345.899 229.771 345.971 229.68 346.025C229.483 346.14 229.25 346.16 229.024 346.179C228.993 346.181 228.963 346.184 228.932 346.186C228.868 346.191 228.803 346.196 228.739 346.202C228.361 346.232 227.985 346.263 227.607 346.293C226.648 346.37 225.541 346.54 225.063 347.41C224.819 347.854 224.817 348.385 224.976 348.878C225.122 349.325 225.384 349.721 225.731 350.024C226.188 350.418 227.341 351.045 228.362 351.495C229.801 352.796 233.94 352.784 239.007 352.769C239.565 352.767 240.134 352.765 240.713 352.765C241.291 352.765 241.86 352.767 242.418 352.769C248.734 352.787 253.608 352.802 253.608 350.274C253.608 347.538 247.896 345.317 240.826 345.293Z",
    fill: "url(#paint4_linear_1230_44876)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M413.965 59.6949C411.056 55.235 406.136 52.4668 400.786 52.2807C397.683 47.5649 392.355 44.7642 386.681 44.8665C382.129 44.8181 377.749 46.5948 374.535 49.7942C373.061 49.3294 371.525 49.0905 369.98 49.086C362.828 49.086 356.907 53.9986 356.315 60.2073C350.863 61.4969 346.938 66.2234 346.704 71.7807C346.704 78.4716 352.883 83.9268 360.369 83.9268H412.842C420.433 83.9268 426.507 78.4716 426.507 71.7807C426.643 65.4214 421.025 60.1621 413.965 59.6949Z",
    fill: "url(#paint5_linear_1230_44876)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M511.949 42.0115C506.774 31.391 495.971 24.6326 484.109 24.596C477.503 24.6102 471.077 26.7417 465.783 30.6747C459.484 18.449 445.805 11.8593 432.261 14.5266C418.717 17.1938 408.59 28.4719 407.446 42.1635C392.876 46.7383 383.836 61.2019 386.153 76.2288C388.471 91.2557 401.454 102.356 416.731 102.373H502.985C518.351 102.402 531.412 91.2103 533.665 76.0847C535.917 60.9591 526.679 46.4789 511.965 42.0723L511.949 42.0115Z",
    fill: "url(#paint6_linear_1230_44876)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.912 155.422C107.878 144.855 98.4367 137.255 87.5241 137.399C81.6669 137.367 76.0126 139.512 71.6897 143.407C69.2339 142.359 66.5774 141.847 63.902 141.905C55.5132 141.762 48.1499 147.382 46.193 155.422C39.7181 156.833 35.049 162.407 34.8696 168.939C35.1186 176.889 41.828 183.152 49.8964 182.967H106.163C114.231 183.152 120.941 176.889 121.19 168.939C121.021 162.418 116.372 156.846 109.912 155.422Z",
    fill: "url(#paint7_linear_1230_44876)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.996 280.382H156V302.012V302.974H156.215C159.829 311.021 208.494 317.394 267.998 317.394C327.502 317.394 376.167 311.021 379.781 302.974H379.996V302.012V280.382Z",
    fill: "url(#paint8_linear_1230_44876)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M267.998 295.763C329.853 295.763 379.996 288.877 379.996 280.382C379.996 271.887 329.853 265 267.998 265C206.143 265 156 271.887 156 280.382C156 288.877 206.143 295.763 267.998 295.763Z",
    fill: "url(#paint9_linear_1230_44876)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M267.998 295.763C329.853 295.763 379.996 288.877 379.996 280.382C379.996 271.887 329.853 265 267.998 265C206.143 265 156 271.887 156 280.382C156 288.877 206.143 295.763 267.998 295.763Z",
    fill: "url(#paint10_linear_1230_44876)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.254 288.496C345.949 293.125 309.626 296.244 267.998 296.244C226.752 296.244 190.714 293.182 171.278 288.623C174.111 280.277 216.461 273.652 268.289 273.652C319.854 273.652 362.036 280.21 365.254 288.496Z",
    fill: "#9CB1FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M337 125.498C329.23 119.75 291.591 110.211 271.265 136.682C245.857 169.771 219.749 203.093 168 182.82",
    stroke: "url(#paint11_linear_1230_44876)",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M326.657 147.038L266.697 128L206.756 147.038C204.503 147.749 202.981 149.846 203 152.218V227.993C203.12 228.508 205.947 240.982 218.203 253.061C227.631 262.352 250.249 274.294 260.114 279.472C261.655 280.284 262.388 280.58 263.039 280.935L265.966 282.397C266.736 282.812 268.121 282.794 268.892 282.397L271.818 280.935C277.59 278.108 304.298 263.796 315.191 253.061C327.468 240.982 330.295 228.508 330.413 227.993V152.218C330.451 149.846 328.911 147.749 326.657 147.038ZM267.448 270.654L267.408 270.635H267.506C267.468 270.654 267.448 270.654 267.448 270.654ZM281.74 226.629H272.053V240.271C272.053 243.434 269.483 246.004 266.32 246.004C263.157 246.004 260.587 243.434 260.587 240.271V205.081C260.587 204.963 260.607 204.865 260.607 204.765C259.56 204.448 258.512 204.072 257.464 203.599C253.926 201.978 250.902 199.072 248.885 195.771C246.789 192.331 245.681 188.02 246.018 183.988C246.413 179.383 248.073 175.368 251.02 171.79C256.12 165.603 265.491 163.093 273.003 165.84C277.253 167.402 280.713 170.012 283.323 173.688C285.616 176.911 286.782 180.923 286.882 184.857C286.882 184.976 286.902 185.074 286.882 185.194C286.882 185.332 286.882 185.47 286.862 185.608C286.586 194.346 280.576 202.589 272.035 204.865V214.926H281.722C284.885 214.926 287.455 217.497 287.455 220.66V220.896H287.475C287.474 224.059 284.903 226.629 281.74 226.629Z",
    fill: "url(#paint12_linear_1230_44876)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M273.3 190.393C273.359 190.295 273.418 190.215 273.438 190.194C273.779 189.672 274.089 189.13 274.368 188.572C274.624 187.841 274.822 187.11 274.98 186.339C275.001 185.964 275.021 185.567 275.04 185.191C275.04 184.814 275.021 184.42 274.98 184.045C274.842 183.294 274.624 182.543 274.368 181.812C274.137 181.346 273.887 180.891 273.616 180.448C273.557 180.388 273.418 180.191 273.182 179.815C272.965 179.576 272.747 179.32 272.51 179.103C272.234 178.827 271.938 178.55 271.621 178.292C271.523 178.234 271.445 178.174 271.423 178.154C270.901 177.813 270.36 177.503 269.802 177.225C269.071 176.968 268.34 176.77 267.589 176.612C266.818 176.553 266.046 176.553 265.275 176.612C264.524 176.75 263.773 176.968 263.062 177.225C262.596 177.455 262.141 177.706 261.697 177.976C261.637 178.036 261.441 178.174 261.064 178.41C260.826 178.627 260.57 178.845 260.353 179.082C260.077 179.358 259.8 179.654 259.542 179.971C259.484 180.069 259.424 180.149 259.404 180.169C259.063 180.691 258.753 181.232 258.474 181.79C258.218 182.521 258.02 183.252 257.861 184.004C257.803 184.775 257.803 185.546 257.861 186.317C258 187.068 258.218 187.819 258.474 188.53C258.711 189.005 258.949 189.44 259.225 189.895C259.285 189.955 259.424 190.151 259.66 190.528C259.877 190.766 260.095 191.022 260.332 191.239C260.608 191.516 260.905 191.792 261.221 192.05C261.319 192.108 261.399 192.168 261.419 192.188C261.932 192.525 262.487 192.841 263.04 193.118C263.771 193.374 264.502 193.573 265.253 193.731C266.024 193.791 266.796 193.791 267.567 193.731C268.318 193.593 269.069 193.374 269.781 193.118C270.255 192.881 270.69 192.643 271.145 192.367C271.205 192.306 271.401 192.168 271.778 191.932C272.034 191.734 272.272 191.517 272.489 191.279C272.767 191.006 273.043 190.709 273.3 190.393Z",
    fill: "url(#paint13_linear_1230_44876)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.768 223.18L177.615 222.372C178.649 221.919 179.852 222.387 180.296 223.395L186.833 238.24C187.277 239.249 186.808 240.448 185.774 240.9L165.363 249.833C164.351 250.276 163.149 249.808 162.705 248.8L156.168 233.955C155.724 232.946 156.192 231.747 157.204 231.304L159.052 230.496L157.42 226.79C155.373 222.142 157.458 216.809 162.099 214.778C166.742 212.746 172.089 214.826 174.136 219.475L175.768 223.18ZM161.845 229.274L172.974 224.403L171.343 220.697C170.694 219.224 169.486 218.067 167.983 217.479C166.481 216.892 164.806 216.922 163.325 217.563C160.268 218.901 158.862 222.498 160.213 225.568L161.845 229.274ZM171.569 240.038C173.676 240.038 175.384 238.335 175.384 236.234C175.384 234.134 173.676 232.43 171.569 232.43C169.462 232.43 167.753 234.134 167.753 236.234C167.753 238.335 169.462 240.038 171.569 240.038Z",
    fill: "url(#paint14_linear_1230_44876)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M341.097 241.107L331.491 242.622L333.03 252.376L342.635 250.862L341.097 241.107Z",
    fill: "url(#paint15_linear_1230_44876)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M339.724 244.473C344.898 243.033 347.745 237.026 346.083 231.055C344.422 225.084 338.88 221.411 333.707 222.851C328.533 224.291 325.686 230.298 327.347 236.269C329.009 242.24 334.55 245.913 339.724 244.473Z",
    fill: "url(#paint16_linear_1230_44876)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.819 219.398C322.57 218.91 324.368 219.451 325.586 220.66C328.426 218.704 332.653 217.243 338.299 219.115C339.17 219.485 339.979 219.92 340.684 220.44C344.291 222.59 345.481 227.524 345.162 228.139C345.014 228.423 344.209 228.812 343.04 229.376C341.077 230.323 338.086 231.767 335.452 234.048C334.842 234.623 334.293 235.145 333.849 235.602L333.849 235.603L333.848 235.601C333.843 235.598 333.838 235.595 333.833 235.592C333.8 235.634 333.768 235.676 333.737 235.719C333.656 235.672 333.558 235.611 333.447 235.541C332.382 234.874 330.038 233.404 328.919 236.336C328.53 240.063 331.913 241.2 333.043 240.467C332.99 241.978 331.527 242.921 331.527 242.921C331.534 242.914 331.518 242.92 331.478 242.935C331.153 243.054 329.271 243.745 326.564 242.311C322.92 240.234 319.802 237.398 319.984 228.655C318.778 228.043 317.819 226.937 317.424 225.519C316.686 222.866 318.205 220.125 320.819 219.398Z",
    fill: "url(#paint17_linear_1230_44876)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M375.825 340.846L371.711 341.086L372.032 346.571L376.145 346.331L375.825 340.846Z",
    fill: "#FEE4C3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M381.561 348.683C381.33 350.565 379.037 350.449 376.025 350.079C373.013 349.71 369.795 349.315 369.364 347.186C369.385 347.279 368.85 345.739 371.146 343.945C371.146 343.945 373.023 345.56 375.917 344.531C378.513 345.381 381.733 347.281 381.561 348.683Z",
    fill: "#4F538F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M389.053 333.324L384.938 333.546L385.235 339.032L389.349 338.81L389.053 333.324Z",
    fill: "#FEE4C3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M395.466 341.857C395.211 343.736 392.919 343.589 389.913 343.179C386.906 342.77 383.693 342.332 383.291 340.199C383.31 340.292 382.795 338.745 385.114 336.981C385.114 336.981 386.97 338.62 389.878 337.63C392.462 338.514 395.657 340.456 395.466 341.857Z",
    fill: "#4F538F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M336.775 293.716C336.775 293.716 339.786 304.821 373.199 304.252C373.199 304.252 375.061 316.976 383.522 334.32L389.526 335.115L384.152 301.513C383.922 300.062 383.326 298.694 382.418 297.537C381.512 296.38 380.324 295.473 378.968 294.9C372.562 292.216 352.033 288.769 352.033 288.769L336.775 293.716Z",
    fill: "#C7DCFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M332.058 292.917C332.058 292.917 331.316 308.554 365.292 311.394C365.292 311.394 365.291 324.816 371.123 342.906L376.663 343.205L377.221 309.176C377.257 307.702 376.916 306.242 376.231 304.937C375.546 303.631 374.539 302.521 373.307 301.713C367.511 297.916 347.937 290.792 347.937 290.792L332.058 292.917Z",
    fill: "#D1E2FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M376.155 282.37C375.703 283.839 374.139 283.605 371.709 283.107C369.279 282.609 366.801 281.695 367.159 279.95C367.516 278.206 370.157 277.132 372.587 277.63C377.857 275.823 380.786 280.908 376.155 282.37Z",
    fill: "url(#paint18_linear_1230_44876)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M316.662 299.176C318.12 299.661 318.838 298.252 319.845 295.986C320.852 293.719 321.549 291.171 319.921 290.448C318.293 289.725 315.885 291.25 314.878 293.518C310.345 296.756 312.781 302.095 316.662 299.176Z",
    fill: "url(#paint19_linear_1230_44876)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.687 246.744C341.687 246.744 346.661 247.713 349.159 250.608C353.275 255.381 356.634 264.143 356.634 264.143C356.634 264.143 357.241 266.878 360.023 270.441C363.05 274.317 363.977 274.711 363.977 274.711C363.977 274.711 367.658 276.369 368.59 276.411C369.727 276.462 372.504 277.171 372.504 277.171L371.627 282.766C371.627 282.766 364.294 283.303 358.852 281.887C354.786 280.828 352.563 276.596 352.563 276.596L341.687 246.744Z",
    fill: "url(#paint20_linear_1230_44876)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M341.753 246.131C338.637 251.067 334.047 248.733 332.141 246.95C331.915 246.985 330.365 248.034 328.603 250.98C325.851 255.581 329.574 282.087 331.488 295.68C342.041 294.944 362.767 292.839 361.253 290.299C359.36 287.123 354.469 264.969 352.72 258.298C352.023 255.643 347.505 247.309 341.753 246.131Z",
    fill: "url(#paint21_linear_1230_44876)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M321.052 256.389C321.932 253.167 327.008 249.984 330.674 248.155C331.361 249.527 332.048 258.447 329.986 261.878C327.924 265.309 327.237 278.347 326.55 279.719C326.058 280.702 323.113 290.698 320.365 294.815C319.677 294.588 317.066 293.446 314.866 293.446C314.866 292.073 316.928 281.092 318.302 278.347C319.225 276.505 318.99 263.937 321.052 256.389Z",
    fill: "url(#paint22_linear_1230_44876)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M343.259 246.631C343.259 246.631 342.474 246.06 341.795 246.167C338.717 250.398 334.178 248.511 332.191 246.986C332.116 246.927 331.512 247.093 330.941 247.878C337.767 252.364 341.997 248.916 343.259 246.631Z",
    fill: "#5B7EFB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M365.321 137.776L345.231 141.983C344.978 142.034 344.742 141.971 344.526 141.8C344.419 141.71 344.332 141.593 344.279 141.454C344.244 141.362 344.227 141.254 344.227 141.131L344.339 135.159C344.345 134.832 344.14 134.539 343.833 134.437L339.571 133.019C339.325 132.943 339.154 132.774 339.056 132.519C339.016 132.413 338.998 132.314 339 132.223C338.999 132.044 339.043 131.881 339.144 131.732C339.243 131.583 339.372 131.475 339.537 131.41L343.333 129.924C343.651 129.799 343.999 129.791 344.324 129.896L360.945 135.382L344.697 126.646C344.574 126.579 344.497 126.449 344.501 126.31L344.608 120.848C344.605 120.497 344.764 120.242 345.096 120.087C345.416 119.941 345.71 119.979 345.975 120.201L365.68 136.276C365.803 136.373 365.888 136.49 365.942 136.632C366.006 136.799 366.016 136.968 365.976 137.137C365.889 137.489 365.665 137.699 365.321 137.776Z",
    fill: "url(#paint23_linear_1230_44876)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1230_44876",
    x1: 272.481,
    y1: 292.666,
    x2: 272.481,
    y2: 400.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95892,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1230_44876",
    x1: 137.43,
    y1: 342.541,
    x2: 137.43,
    y2: 291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7893,
    stopColor: "#DFF0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1230_44876",
    x1: 137.431,
    y1: 296.723,
    x2: 137.431,
    y2: 353.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#A2BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1230_44876",
    x1: 426.964,
    y1: 292.494,
    x2: 413.152,
    y2: 322.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365159,
    stopColor: "#D5D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1230_44876",
    x1: 240.713,
    y1: 359.362,
    x2: 224.133,
    y2: 329.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164037,
    stopColor: "#D5D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3B5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1230_44876",
    x1: 386.681,
    y1: 83.9268,
    x2: 386.681,
    y2: 44.8665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DBFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F8FBFF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EDF5FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4F0FF",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DEECFF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#DAEAFF",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1230_44876",
    x1: 459.873,
    y1: 102.312,
    x2: 459.873,
    y2: 13.8671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FEFEFF",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FBFCFF",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F5F9FF",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EEF5FF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E4EFFF",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1230_44876",
    x1: 78.0296,
    y1: 183.072,
    x2: 78.0296,
    y2: 137.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1230_44876",
    x1: 332.869,
    y1: 277.017,
    x2: 302.5,
    y2: 370,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1230_44876",
    x1: 317.404,
    y1: 266.572,
    x2: 313.981,
    y2: 298.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656831,
    stopColor: "#8FC8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1230_44876",
    x1: 317.404,
    y1: 266.572,
    x2: 313.981,
    y2: 298.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B98FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656831,
    stopColor: "#A9BEFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1230_44876",
    x1: 277.514,
    y1: 120.02,
    x2: 258.087,
    y2: 192.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656831,
    stopColor: "#C7CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1230_44876",
    x1: 294.81,
    y1: 135.905,
    x2: 194.961,
    y2: 226.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.193281,
    stopColor: "#8FA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989722,
    stopColor: "#D5D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1230_44876",
    x1: 270.228,
    y1: 177.447,
    x2: 262.379,
    y2: 191.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656831,
    stopColor: "#CFD5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1230_44876",
    x1: 178.338,
    y1: 215.839,
    x2: 160.72,
    y2: 243.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656831,
    stopColor: "#CFD5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1230_44876",
    x1: 336.493,
    y1: 243.125,
    x2: 337.833,
    y2: 251.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1230_44876",
    x1: 332.267,
    y1: 223.251,
    x2: 348.886,
    y2: 240.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE0BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1230_44876",
    x1: 338.838,
    y1: 222.431,
    x2: 324.561,
    y2: 241.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F4326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#574915"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1230_44876",
    x1: 373.463,
    y1: 276.872,
    x2: 372.167,
    y2: 283.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE4C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1230_44876",
    x1: 313.752,
    y1: 293.791,
    x2: 319.655,
    y2: 296.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE4C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD1AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1230_44876",
    x1: 339.413,
    y1: 292.271,
    x2: 346.445,
    y2: 246.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0403741,
    stopColor: "#6688FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F094FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1230_44876",
    x1: 339.413,
    y1: 292.271,
    x2: 346.445,
    y2: 246.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0403741,
    stopColor: "#6688FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F094FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1230_44876",
    x1: 339.413,
    y1: 292.271,
    x2: 346.445,
    y2: 246.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0403741,
    stopColor: "#6688FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F094FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1230_44876",
    x1: 362.741,
    y1: 131.64,
    x2: 340.848,
    y2: 128.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656831,
    stopColor: "#D3D7FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.cb980f0400ff48fbbd790221114be68c.svg";
export { ForwardRef as ReactComponent };